export default __webpack_public_path__ + "static/media/jansen-signature.89ad372e.png";